<div class="clr-row">
  <div class="clr-col">
    <lib-map [geojson]="data" [clearMap]="clearMap"> </lib-map>
  </div>
  <div class="clr-col-5">
    <lib-geojson-viewer
      (geojsonData)="onGeojsonData($event)"
      (clearMap)="onClearMap($event)"
    >
    </lib-geojson-viewer>
  </div>
  <!-- <div class="floatingMenubar">
    <div *ngIf="toggleDataEditor">
      <clr-icon
        shape="angle-double"
        class="is-solid"
        size="24"
        style="transform: rotate(90deg);"
        (click)="toggleGeojsonViewer()"
        title="Geojson Editor"
      ></clr-icon>
    </div>
    <div *ngIf="!toggleDataEditor">
      <clr-icon
        shape="angle-double"
        class="is-solid"
        size="24"
        style="transform: rotate(270deg);"
        (click)="toggleGeojsonViewer()"
        title="Geojson Editor"
      ></clr-icon>
    </div>
  </div> -->
</div>
